export default function toStore() {
    if (navigator.vendor === 'Apple Computer, Inc.') {
        window.open('https://apps.apple.com/in/app/ricciwawa/id1579274573'); 
    } else {
        window.open('https://play.google.com/store/apps/details?id=com.makebell.ricciwawa');
    }
}